module.exports = __webpack_public_path__ + "5fa6d7ddc0a0d53311752343d7176d70.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/lato/lato-bolditalic-webfont.woff2
 ** module id = ./src/styles/fonts/lato/lato-bolditalic-webfont.woff2
 ** module chunks = 0
 **/